export default __webpack_public_path__ + "static/media/cleanhackers.0c23f3ab.png";